import { useCallback } from 'react';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

import { useCopyToClipboard } from '../hooks/useCopyToClipboard.hook';

interface Props {
  readonly content: string;
  readonly size?: 'small' | 'medium' | 'large';
}

export const CopyToClipboard = ({
  content,
  size = 'medium',
}: Readonly<Props>) => {
  const { copyToClipboard } = useCopyToClipboard();

  const handleClick = useCallback(() => {
    copyToClipboard(content);
  }, [content, copyToClipboard]);

  return (
    <Tooltip title="Copier le contenu">
      <IconButton
        aria-label="Copier le contenu"
        onClick={handleClick}
        size={size}
      >
        <ContentPasteIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
};
